import React from 'react';
import tw from 'twin.macro';

interface Props {
  onClick: (e: React.MouseEvent<HTMLSpanElement>) => void;
  active: boolean;
  children: React.ReactNode;
  className?: string;
  size?: 'md' | 'lg';
  'data-testid'?: string;
}

export function ButtonDisplay(props: Props) {
  const { onClick, active, className, size = 'md' } = props;
  return (
    <span
      className={className}
      onClick={e => onClick(e)}
      data-testid={props['data-testid']}
      css={[
        tw`
          rounded-md cursor-pointer
          font-medium
          inline-flex items-center gap-x-0.5
          ring-inset
        `,
        // Un peu de la merde le coup du leading, mais bon faudra voir pour faire mieux
        size === 'md' &&
          tw`px-2 py-1 text-neutral-moderate text-sm leading-[16px]!`,
        size === 'lg' && tw`px-3 py-2 text-base leading-[18px]!`,
        !active && tw`ring-1 ring-inset ring-neutral-quiet`,
        active && tw`bg-brand-moderate text-brand-intense`,
        !active &&
          tw`hover:ring-1 hover:ring-neutral-quiet hover:bg-neutral-supershy hover:text-neutral-moderate`,
        !active &&
          tw`active:ring-1 active:ring-neutral-quiet active:bg-neutral-quiet active:text-neutral-moderate`,
      ]}
    >
      {props.children}
    </span>
  );
}
